import { HiX } from "react-icons/hi";
import { FaRegChartBar, FaCog, FaRegUser, FaProjectDiagram, FaGraduationCap, FaRegUserCircle, FaRegFile, FaRegCreditCard } from "react-icons/fa";
import { NavLink } from "react-router-dom";

function Sidebar() {
    return (
        <div className="sideBar text-[15px] bg-white px-5 pt-3 absolute md:relative z-50 min-w-[220px] h-full left-[-220px] duration-500 md:left-[0] max-w-[220px]">
            <div className="brand h-12 font-bold flex flex-col items-center">
                <HiX className="xmark md:hidden absolute left-4 top-6 hover:cursor-pointer" />
                <h1 className=" flex justify-center relative pb-3 px-4 text-xl  before:absolute before:w-full before:h-[2px] before:bottom-0 before:bg-black after:absolute after:bottom-[-4px] after:left-1/2 after:-translate-x-1/2 after:w-3 after:h-3 after:rounded-full after:bg-black after:shadow-0b3swhite">Zana</h1>
            </div>
            <ul className="mt-4">
                <li className="rounded-[5px] mb-1 hover:bg-gray-100">

                    <NavLink to={"/"} className="flex items-center w-full p-[9px] rounded-[5px]">
                        <FaRegChartBar />
                        <span className="ml-2">Dashboard</span>
                    </NavLink>
                </li>

                <li className="rounded-[5px] mb-1 hover:bg-gray-100">
                    <NavLink to={"/Settings"} className="flex items-center w-full p-[9px] rounded-[5px]">
                        <FaCog />
                        <span className="ml-2">Settings</span>
                    </NavLink>
                </li>

                <li className="rounded-[5px] mb-1 hover:bg-gray-100">
                    <NavLink to={"/Profile"} className="flex items-center w-full p-[9px] rounded-[5px]">
                        <FaRegUser /><span className="ml-2">Profile</span>
                    </NavLink>
                </li>

                <li className="rounded-[5px] mb-1 hover:bg-gray-100">
                    <NavLink to={"/Projects"} className="flex items-center w-full p-[9px] rounded-[5px]">
                        <FaProjectDiagram /><span className="ml-2">Projects</span>
                    </NavLink>
                </li>

                <li className="rounded-[5px] mb-1 hover:bg-gray-100">
                    <NavLink to={"/Courses"} className="flex items-center w-full p-[9px] rounded-[5px]">
                        <FaGraduationCap /><span className="ml-2">Courses</span>
                    </NavLink>
                </li>

                <li className="rounded-[5px] mb-1 hover:bg-gray-100">
                    <NavLink to={"/Friends"} className="flex items-center w-full p-[9px] rounded-[5px]">
                        <FaRegUserCircle /><span className="ml-2">Friends</span>
                    </NavLink>
                </li>

                <li className="rounded-[5px] mb-1 hover:bg-gray-100">
                    <NavLink to={"/Files"} className="flex items-center w-full p-[9px] rounded-[5px]">
                        <FaRegFile /> <span className="ml-2">Files</span>
                    </NavLink>
                </li>

                <li className="rounded-[5px] mb-1 hover:bg-gray-100">
                    <NavLink to={"/Plans"} className="flex items-center w-full p-[9px] rounded-[5px]">
                        <FaRegCreditCard /><span className="ml-2">Plans</span>
                    </NavLink>
                </li>
            </ul>
        </div>
    )
}

export default Sidebar